export const loginContent = {
  banner: 'Please log in to access this page',
  prompt: [
    'Log in below with your University of Salford account to view your current timetable. Visit ',
    {
      href: 'https://www.salford.ac.uk/askus/topics/admin-essentials/timetable-guidance',
      text: 'our timetable guidance page',
    },
    ' for general information about timetables.',
  ],
  loginButton: 'Log in with your University account',
  courseTimetablePrompt:
    'You can also view the public timetable for your course without logging in. ',
  courseTimetableButton: 'View a Course Timetable',
  whatIsCourseTimetableHeading: 'What is a Course Timetable?',
  whatIsCourseTimetableBody:
    'A course timetable (also known as a programme timetable) will show all the teaching events scheduled over the year for that course for each year level. Most courses split students into groups for smaller classes and the course timetable shows all events for all groups. This means that a course timetable may show events that you don’t need to attend.',
  newStudentInfoHeading: 'Information for new students',
  newStudentInfoBody: [
    'If you are a new student, your personal or group-level timetables are generally made available during your induction activities. You can find more information about your timetable on ',
    {
      href: 'https://www.salford.ac.uk/askus/topics/admin-essentials/timetable-guidance',
      text: 'our timetable guidance page',
    },
  ],
} as const;
